import { Outlet, useLocation } from 'react-router-dom'
import { SocialOrdersFiltration } from '../../../../components/SocialOrders/SocialOrdersFiltration'
import { FormBlock } from '../../../../common/FormGenerator'
import { getFormConfig } from '../../../../components/SocialOrders/SocialOrdersFiltration/settingsConfig'
import { FormProvider, useForm } from 'react-hook-form'
import { PageLayout } from '../../../../components/PageLayout'
import { SocialOrdersTabs } from '../../../../components/SocialOrders/SocialOrdersTabs'
import { useEffect, useLayoutEffect, useMemo } from 'react'

const normalizeStringValue = (value: string | null): string => value?.trim() ?? ''

export const SocialOrdersLayout = () => {
  useLayoutEffect(() => {
    document.title = 'Соц-заказы'
  }, [])

  const { search } = useLocation()
  const defaultValues = useMemo(() => {
    const searchParams = new URLSearchParams(search)
    return {
      search: normalizeStringValue(searchParams.get('query')),
      focus: searchParams.getAll('focus[]').map((v) => v.trim()).filter(Boolean),
    }
  }, [search])

  const methods = useForm({ mode: 'all', defaultValues })

  useEffect(() => {
    methods.reset(defaultValues)
  }, [defaultValues, methods])

  return (
    <FormProvider {...methods}>
      <PageLayout
        title="Соц-заказы"
        mainComponent={<Outlet />}
        sideComponent={<SocialOrdersFiltration />}
        searchComponent={<FormBlock formFieldConfig={getFormConfig('search')} />}
        topComponent={<SocialOrdersTabs />}
      />
    </FormProvider>
  )
}
